<!-- User Button -->
@if(!isIframe) {
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && user.avatar) {
        <img class="h-7 w-7 rounded-full" [src]="user.avatar" />
        }
        @if (!showAvatar || !user.avatar) {
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    @if(userType === 'BUSINESS') {
    <button mat-menu-item>
        <span class="flex flex-col leading-[9px]">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium"> {{ user?.fullName }} ({{ user?.loginId }})</span>
        </span>
    </button>

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="navigateTo('profile')">
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Settings </span>
    </button>

    <mat-divider class="my-2"></mat-divider>
    }
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>
}